/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */

// Plan Wizard
export const ALERTTYPE = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
};

export const OPERATION = {
    CREATE: 'CREATE',
    EDIT: 'EDIT'
};

export const ROLLUP_TYPES = [
    { type: 'YES', label: 'Yes' },
    { type: 'NO_CROSS_MARKET', label: 'No Cross-Market' },
    { type: 'NO_CROSS_REGION', label: 'No Cross-Region' }
];

export const EARNING_TYPES = {
    COMP: 'COMP',
    ADJUSTMENT: 'ADJUSTMENT'
};

export const REG_EXP_LIST = {
    defaultPassword: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?=\S+$).{12,30}$/,
    administratorPassword: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?=\S+$).{16,30}$/
};

// export const VOLUME_TYPES_OPTIONS = [
//     { type: 'DIRECT', label: 'Direct' },
//     { type: 'DIRECTED', label: 'Directed' },
//     { type: 'PERSONAL_GROUP', label: 'Personal Group' },
//     { type: 'LEADER_GROUP', label: 'Leader Group' },
//     { type: 'CUMULATIVE_FIXED', label: 'Cumulative - Fixed' },
//     { type: 'CUMULATIVE_ROLLING', label: 'Cumulative - Rolling' },
//     { type: 'SPONSOR_GROUP', label: 'Sponsor Group' },
//     { type: 'SYNTHETIC', label: 'Synthetic' },
//     { type: 'FIRST_UPLINE', label: 'Sponsor' }
// ];

// Commenting VOLUME_SUBTYPES_OPTIONS as part of MLM-3443
// export const VOLUME_SUBTYPES_OPTIONS = [
//     { type: 'QOV', label: 'Qualified Organization Volume' },
//     { type: 'BGV', label: 'Business Group Volume' },
//     { type: 'UGV', label: 'Unencumbered Group Volume' },
//     { type: 'CV', label: 'Car Volume' }
// ];

export const VOLUME_APPLIES_TO = [
    { type: 'NA', label: 'NA' },
    { type: 'ALL', label: 'All' },
    { type: 'LEADER', label: 'Leader' }
];

export const BUSINESS_RULES_VOLUME_TYPES_OPTIONS = [
    { type: 'DIRECT', label: 'Direct' },
    { type: 'PERSONAL_GROUP', label: 'Personal Group' },
    { type: 'LEADER_GROUP', label: 'Leader Group' }
];

export const EQUIVALENCY_TYPES_OPTIONS = [
    { type: 'PERSONAL_GROUP', label: 'Personal Group' },
    { type: 'LEADER_GROUP', label: 'Leader Group' },
    { type: 'SPONSOR_GROUP', label: 'Sponsor Group' }
];


/* As per Harinath suggestions, I am removing the earlier options */
export const PLAN_STATUS_OPTIONS = [
    { type: 'Draft', label: 'Draft' },
    { type: 'Active', label: 'Active' }
];

export const PROMOTE_TYPE_OPTIONS = [
    { type: 'AUTO_MANUAL', label: 'Auto & Manual' },
    { type: 'AUTO', label: 'Auto' },
    { type: 'MANUAL', label: 'Manual' },
    { type: 'REALTIME', label: 'Realtime' }
];

export const AG_GRID_CONFIG = {
    startingPageNumber: 1,
    startingPageMaxId: 0,
    recordsPerPage: 100,
    ordersRecordsPerPage: 500,
    analyticsRecordsPerPage: 1000,
    auditRecordsPerPage: 5000,
    specificColTypes: ['Order', 'VolumeTransfer', 'Audit Logs', 'Compensation', 'Payments', 'Incentive',"Activity Logs"],
    orderTypes: ['Order', 'VolumeTransfer'],
    bonusColTypes: ['Compensation'],
    paymentColTypes: ['Payments'],
    incentiveColTypes: ['Incentive'],
    /* recordsPerPage key should have a value out of the list of values present in recordsPerPageOptions.*/
    recordsPerPageOptions: [25, 50, 100, 500, 1000, 3000, 5000, 7000, 10000, 25000, 50000],
    recordsOrderPerPageOptions: [25, 50, 100, 500, 1000, 3000, 5000, 7000, 10000, 25000]
};

export const SHARE_HANDLE_CONFIG = {
    shUnitValueOptions: [0, 15, 25, 33, 50, 75, 100]
};

export const GRID_ICONS = {
  icons: {
    // use font awesome for menu icons
    menu: '<i class="fa fa-sliders"/>',
    // filter: '<i class="grid-filter fa fa-filter"/>',
    columns: '<i class="fa fa-columns"/>',
    sortAscending: '<i class="asc fa fa-long-arrow-up"/>',
    sortDescending: '<i class="desc fa fa-long-arrow-down"/>',
    groupExpanded: '<i class="fa fa-minus"/>',
    groupContracted: '<i class="fa fa-plus"/>',
    columnMovePin: '<i class="fa fa-hand-grab-o"/>',
    columnMoveAdd: '<i class="fa fa-plus-square-o"/>',
    columnMoveHide: '<i class="fa fa-remove"/>',
    columnMoveMove: '<i class="fa fa-chain"/>',
    columnMoveLeft: '<i class="fa fa-arrow-left"/>',
    columnMoveRight: '<i class="fa fa-arrow-right"/>',
    columnMoveGroup: '<i class="fa fa-group"/>',
    pivotPanel: '<i class="fa fa-magic"/>',
    valuePanel: '<i class="fa fa-magnet"/>',
    menuPin: '<i class="fa fa-map-pin"/>', // just showing letters, no graphic
    // Deprecated
    
    // checkboxChecked: '<i class="fa fa-check-square-o"/>',
    // checkboxUnchecked: '<i class="fa fa-square-o"/>',
    // checkboxIndeterminate: '<i class="fa fa-circle-o"/>'
  },
  defaultColDef: {
    resizable: true,
    sortable: true,
    filter: true
  }
};

export const SIDE_MENU_ICONS = {
    'DPR': 'icon-company-view',
    'LNGV': 'icon-tree',
    'HOM': 'icon-home',
    'BKM': 'icon-favorite-list',
    'RCV': 'icon-history',
    'FST': 'icon-headset',
    'TRF': 'icon-paper-plane',
    'GLY': 'icon-tree',
    'LNG': 'icon-tree',
    'CPN': 'icon-sales-quote',
    'DVS': 'icon-sales-quote',
    'INCA': 'icon-sales-quote',
    'COM': 'icon-commission-check',
    'ASP': 'icon-wrench',
    'ADM': 'icon-user-settings',
    'DEM': 'icon-laptop',
    'UAT': 'icon-laptop',
    'PFL': 'icon-person-placeholder',
    'FLP' : 'icon-employee-lookup',
    'FOS' : 'icon-sales-order',
    'ALG' : 'icon-activity-items',
    'ACLG' : 'icon-activity-items',
    'VTR' : 'icon-paper-plane',
    'MOVR': 'icon-past',
    'GLV' : 'icon-tree',
    'CSR' : 'icon-customer',
    'RTN' : 'icon-validate',
    'UJE' : 'icon-sales-quote',
    'ALT' : 'icon-vertical-bar-chart',
    'TCS' : 'icon-commission-check',
    'PAL' : 'icon-money-bills',
    'AHP' : 'icon-money-bills',
    //add icon for adhoc payment TODO
    'MNB' : 'icon-appointment',
    'CPG' : 'icon-accounting-document-verification',
    'CAJ' : 'icon-collections-insight',
    'ENC' : 'icon-receipt',
    'CMB' : 'icon-capital-projects',
    'BNB' : 'icon-lead',
    'BSP' : 'icon-building',
    'GBE' : 'icon-crm-service-manager',
    'PBR' : 'icon-activity-2',
    'UGS' : 'icon-user-settings',
    'DIN' : 'icon-database',
    'MEM' : 'icon-add-employee',
    'ORD' : 'icon-create-form',
    'DBU' : 'icon-split',
    'AC'  : 'icon-compare',
    'LHR' : 'icon-customer-history',
    'ACG' : 'icon-inspect',
    'CBAL': 'icon-pdf-reader',
    'INTL': 'icon-it-host',
    'INBL': 'icon-activity-items',
    'IBOBL': 'icon-activity-items',
    'GDPR': 'icon-private',
    'ADHP': 'icon-simple-payment',
    'MSR': 'icon-manager-insight',
    'VLDIF':'icon-compare-2',
    'SYSAD':'icon-employee-pane',
    'MPMC': 'icon-opportunity',
    'SOR': 'icon-sales-order',
    'MVAR': 'icon-windows-doors',
    'AHR': 'icon-customer-history',
    'LTA': 'icon-world',
    'AHPR': 'icon-money-bills',
    'ULR': 'icon-activity-items',
    'ADG' : 'icon-archive',
    'AOR' : 'icon-sales-order',
    'APR' : 'icon-money-bills',
    'IML': 'icon-activity-items',
};

export const PROCESSING_TYPE_OPTIONS = [
    { type: 'Active', label: 'Active' },
    { type: 'Inactive', label: 'Inactive' },
    { type: 'Remove', label: 'Remove' },
    { type: 'General Data Protection Regulation', label: 'GDPR' },
    { type: 'Activity Logs', label: 'ACLG' },
    { type: 'Activity Logs Create Reports', label: 'ACLCR' },
    { type: 'Activity Logs Save Reports', label: 'ACLNR' },
    { type: 'Activity Logs Share Reports', label: 'ACLSR' },
    { type: 'Activity Logs Download Reports', label: 'ACLDR' },
];

export const GENEALOGY_OPTIONS = [
    { type: 'Active', label: 'Active' },
    { type: 'Inactive', label: 'Inactive' },
    { type: 'Remove', label: 'Remove' }
];

/* These 2 constants will be deleted with real data once APIs are ready */
export const GLOBAL_COMP_SETUP_TYPE = [
    { id: 'Differential', label: 'Differential' },
    { id: 'Generational', label: 'Generational' },
    { id: 'Fast Start', label: 'Fast Start' },
];

export const GLOBAL_COMP_SETUP_ROLL_TYPE = [
    { id: 'Personal Group1', label: 'Personal Group1' },
    { id: 'Personal Group2', label: 'Personal Group2' },
    { id: 'Personal Group3', label: 'Personal Group3' },
];

export const DOWNLINE_LEVEL = [
    { id: 1, label: '1' },
    { id: 2, label: '2' },
    { id: 3, label: '3' },
    { id: 4, label: '4' },
    { id: 5, label: '5' },
    { id: 6, label: '6' },
    { id: 7, label: '7' },
    { id: 8, label: '8' },
    { id: 9, label: '9' },
    { id: 10, label: '10' },
    { id: 11, label: 'Infinity' },
];

export const INCENTIVE_STATUSES = {
    ACTIVE: 'Active',
    PENDING: 'Pending',
    COMPLETED: 'Completed'
};

export const USERGROUP_OPERATION = {
    SINGLEREMOVE: 'SINGLEREMOVE',
    MULTIPLEREMOVE: 'MULTIPLEREMOVE',
    MULTIPLEDELETE: 'MULTIPLEDELETE'
};

export const EDIT_OPERATION_CODE = {
    price_tier_edit: 'PRICETIEREDIT',
    s_and_h_edit: 'SHSHARINGEDIT',
    change_comp_plan_edit: 'PLANEDIT',
    pdd_edit: 'PDDEDIT'
};

export const TAX_FEE_CONSTANTS = {
    checkAmountCode: 'CHA',
    AmountHeldOnAccCode: 'AHA',
    gstSalesTaxCode: 'GST',
    hstSalesTaxCode: 'HST'
};

export const PERIOD_TYPES = {
    untilUnset: 'Until Unset',
    planPeriod: 'Date Range',
    untilReversion: 'Until Reversion'
};

export const LEADERSHIP_TYPES = [
    { type: 'leader', label: 'Leader' },
    { type: 'non-leader', label: 'Non-Leader' }
];

export const FILTER_PATTERN_OPTIONS = [
    { label: '=', value: '='},
    { label: '<', value: '<'},
    { label: '>', value: '>'},
    { label: '!=', value: '!='},
];

export const JOIN_FILTER_PATTERN_OPTIONS = [
    { label: '=', value: '='},
    { label: '<', value: '<'},
    { label: '>', value: '>'},
    { label: '!=', value: '!='},
    { label: '<->', value: '<->'}
];

export const CHANGE_SPONSOR = {
    participant: 'Participant',
    personalGroup: 'PersonalGroup',
    downlineLeg: 'Leg'
};

export const RATE_TYPES = {
    fixed: 'Fixed',
    percentage: 'Percentage',
    amount: 'Amount',
    salesOrder: 'Sales Order'
};

export const RATECARD_COMP_TYPES = {
  UNIT_BASED: 'Unit Based',
  PRODUCTIVITY_BONUS: 'Productivity Bonus',
  ONO_BONUS: 'One on One Bonus',
  TEAM_LEADER_TARGET_BONUS: 'Team Leader Target Bonus',
  SENIOR_TEAM_LEADER_BONUS: 'Senior Team Leader Bonus',
  BRANCH_MANAGER_BONUS: 'Branch Manager Bonus',
  DEVELOPMENT_BONUS: 'Development Bonus',
  NEWCOMER_COMMISSION: 'Newcomer Commission',
  VOLUME_BASED: 'Volume Based',
  VOLUME_RANGE_BASED: 'Volume Range Based',
  CHANNEL_UNIT: 'Order Unit',
  //   CUMULATIVE_UNIT: 'Cumulative Unit',
  LINEAL_UNIT: 'Lineal Unit',
  VOLUME_UNIT: 'Volume Unit',
  CONDITION_UNIT: 'Condition Unit',
  RECRUITMENT_UNIT: 'Recruitment Unit',
  EVENT_BASED: 'Event Based',
  DEPENDENT_UNIT: 'Dependent Unit',
  EARNING_ORDER_UNIT: 'Earning Order Unit',
  EARNING_ORDER_SALE: 'Earning Order Sale',
  ORDER_BASED: 'Order Based',
  DOWNLINE_CRITERIA_BASED:'Downline Criteria Based',
  CRITERIA_BASED:'Criteria Based',
  OWNER_ORDER_UNIT: 'Owner Order Unit',
  CRITERIA_RANGE_BASED: 'Criteria Range Based',
  RECRUITMENT_TYPE_BASED: 'Recruitment Type Based'
};

export const RC_LIMIT_TYPES = {
    participant: 'Participant',
    volume: 'Volume',
    periods: 'Periods'
};

export const DIRECTED_SOURCES = [
    { type: 'order', label: 'Order' }
];

export const CURRENCY_TYPES = [
    { type: 'USD', label: 'USD ($)' },
];

export const COMPANY_CODES = {
    thermomixTaiwan: 'TMTW',
    thermomixUK: 'TMUK',
    thermomixSpain: 'TMES',
    thermomixKobald: 'KSES',
    thermomixPoland: 'TMPL',
    kobaldPoland: 'KSPL',
    thermomixMY: 'TMMY',
    thermomixSG: 'TMSG',
    kobaldMY: 'KSMY',
    thermomixItaly: 'TMIT',
    kobaldItaly: 'KSIT',
    kobaldSpain: 'KSES',
    thermomixRomania: 'TMRO',
};

export const REGION_CODES = {
    TMES: 'ES',
    KSES: 'ES',
    TMUK: 'UK',
    TMPL: 'PL',
    KSPL : 'PL',
    TMTW: 'TW',
    TMMY: 'MY',
    TMSG: 'SG',
    TMIT: 'IT',
    KSIT: 'IT'
}

export const COMPANY_TRANSLATION_CODES = {
    'TMTW': 'en'
};

export const COMPANY_BASED_TIME_ZONES = {
    'TMTW': 'Asia/Taipei',
    'MJN': 'America/Los_Angeles',
    'SHK': 'America/Los_Angeles'
};

export const MODULE_NAME_CODES = {
    'Distributors': "DIST",
    'Genealogies': "GNY",
    'Reports': "RPT"
}

export const USER_GROUP_TYPES = {
    'distBankOfc': "DBO",
    'empApplication': "EA"
}

export const FEATURES_CODES = {
  'Historical Report': 'LHR',
  'User Activity Update': 'USAU',
  'User Activity View': 'USAV',
  'Field Support': 'FST',
  'Field Lookup': 'FLP',
  'Card View': 'CDV',
  'Grid View': 'GDV',
  'Grid Create Reports': 'GRCN',
  'Grid Save Reports': 'GRSN',
  'Grid Share Reports': 'GRSR',
  'Grid Download Reports': 'GRDR',
  'Distributor Detail View': 'DDV',
  'Field Orders': 'FOS',
  'Field Orders View': 'FOV',
  'Field Create Reports': 'FCN',
  'Field Save Reports': 'FSN',
  'Field Share Reports': 'FSR',
  'Field Download Reports': 'FDR',
  'Integration Logs': 'INTL',
  'Inbound Logs': 'INBL',
  'InboundOutbound Logs': 'IBOBL',
  'Adhoc Payments': 'ADHP',
  'Volume Transfer': 'VLTR',
  'Move Order Volume': 'MOVR',
  Genealogy: 'GLY',
  'Genealogy View & Lookup': 'GVL',
  'Genealogy Create Reports': 'GCN',
  'Genealogy Save Reports': 'GSN',
  'Genealogy Share Reports': 'GSR',
  'Genealogy Download Reports': 'GNDR',
  'Unjust Enrichment View': 'UJEV',
  'Change Sponsor': 'CSR',
  'Status Change': 'RTN',
  'Compensation Analytics': 'CAS',
  'Analytics View': 'ALTV',
  'Compensation Create Reports': 'CNCR',
  'Compensation Save Reports': 'CASR',
  'Compensation Share Reports': 'CNSR',
  'Compensation Download Reports': 'CNDR',
  'Incentive View': 'INCV',
  'Incentive Update': 'INCU',
  'Incentive Analytics View': 'INCAV',
  'Incentive Analytics Update': 'INCAU',
  'Incentive Create Reports': 'INCCR',
  'Incentive Save Reports': 'INCSR',
  'Incentive Share Reports': 'INCSH',
  'Incentive Download Reports': 'INCDR',
  'Payment Analytics': 'PAS',
  'Payment Update': 'PASU',
  'Payment View': 'PASV',
  'Payment Create Reports': 'PACR',
  'Payment Save Reports': 'PASR',
  'Payment Share Reports': 'PASH',
  'Payment Download Reports': 'PADR',
  'Misc Report View': 'MSRV',
  'Misc Create Reports': 'MSCR',
  'Misc Save Reports': 'MSSR',
  'Misc Share Reports': 'MSSH',
  'Misc Download Reports': 'PADR',
  'Commission Processing': 'COMP',
  'Commission Run Update': 'CMRU',
  'Commission Run View': 'CMRV',
  'Period Close': 'PRDC',
  'Re-Process': 'PRRP',
  'Business Setup': 'BSET',
  'Company Update': 'CMU',
  'Company View': 'CMV',
//   'Company Authentication Update': 'CAUU',
//   'Company Authentication View': 'CAUV',
  'Audit Configuration Update': 'ACFU',
  'Audit Configuration View': 'ACFV',
  'Global Settings Update': 'GSTU',
  'Global Settings View': 'GSTV',
  'Omni Channel Update': 'OMNCU',
  'Omni Channel View': 'OMNCV',
  'Value Chain Rule Update': 'VCRU',
  'Value Chain Rule View': 'VCRV',
  'Volume Configuration View': 'VCV',
  'Volume Configuration Update': 'VCU',
  'Genealogy Configuration Update': 'GENU',
  'Genealogy Configuration View': 'GENV',
  'Markets & Regions Update': 'MKRU',
  'Markets & Regions View': 'MKRV',
  'Plan Period Update': 'PLPU',
  'Plan Period View': 'PLPV',
  'Plan Period Segment Definition View': 'PPSDV',
  'Plan Period Segment Definition Update': 'PPSDU',
  'Income Tax Setup Update': 'ITSU',
  'Income Tax Setup View': 'ITSV',
  'Global Plan Elements': 'GLPE',
  'Volumes Update': 'GVOLU',
  'Volumes View': 'GVOLV',
  'Key Metrics Update': 'KMU',
  'Key Metrics View': 'KMV',
  'Title Types Update': 'TTU',
  'Title Types View': 'TTV',
  'Participant Status Update': 'PTSU',
  'Participant Status View': 'PTSV',
  'Overrides Update': 'OVU',
  'Overrides View': 'OVV',
  'Flags Update': 'FLGU',
  'Flags View': 'FLGV',
  'Incentive Plan Update': 'INPU',
  'Incentive Plan View': 'INPV',
  'Incentive Point View': 'INPOV',
  'Incentive Point Update': 'INPOU',
  'Cost Center Type Update': 'CCTU',
  'Cost Center Type View': 'CCTV',
  'Job Configuration Update': 'JCU',
  'Job Configuration View': 'JCV',
  'Material Processing Update': 'PCU',
  'Material Processing View': 'PCV',
  'Rewards Update': 'GRU',
  'Rewards View': 'GRV',
  'Plan Builder': 'PBLD',
  'Plan Update': 'PLU',
  'Plan View': 'PLV',
  'ValueChain Volume': 'VOLV',
  'Challenge Program Update': 'CPU',
  'Challenge Program View': 'CPV',
  'Title Update': 'TITU',
  'Title View': 'TITV',
  'Title Level Update': 'TITLU',
  'Title Level View': 'TITLV',
  'Charges & Fees Update': 'CFU',
  'Charges & Fees View': 'CFV',
  'Compensation Builder': 'CBLD',
  'Compensation Global Update': 'CPGU',
  'Compensation Global View': 'CPGV',
  'Compensation Plan Update': 'CPPU',
  'Compensation Plan View': 'CPPV',
  'Compensation Rate Card Update': 'CRCU',
  'Compensation Rate Card View': 'CRCV',
  'Download Combined Statement': 'DCS',
  'Change OrganizationUnit': 'COR',
  'Change Parent OrganizationUnit': 'CPR',
  'Change OrganizationUnit Downline': 'COD',
  Administration: 'ADM',
  'Users & Groups Update': 'UGSU',
  'Users & Groups View': 'UGSV',
  'Data Integration': 'DIN',
  'Job Update': 'JOBU',
  'General Data Protection Regulation': 'GDPR',
  'Job View': 'JOBV',
  Demo: 'DEM',
  'Members Update': 'MEMU',
  'Members View': 'MEMV',
  'Distributor Update Update': 'DBUU',
  'Distributor Update View': 'DBUV',
  'Orders Update': 'ORDU',
  'Orders View': 'ORDV',
  Profile: 'PFL',
  'Profile Update': 'PFLU',
  'Profile View': 'PFLV',
  'NHI Bank Lien Update': 'NBLU',
  'Translation Update': 'TRAU',
  'Translation View': 'TRAV',
  'Help Update': 'HLPU',
  'Challenge Program Tab Code': 'PCPV',
  'Plan List Tab Code': 'APLV',
  'Plan Confirmation Tab Code': 'PSCP',
  'Period High Title Job': 'PHTJ',
  'Volume Transfer View': 'VTV',
  'Volume Transfer Update': 'VTU',
  'Volume Transfer Setup View': 'VTPV',
  'Volume Transfer Setup Update': 'VTPU',
  'Volume Transfer Admin Override': 'VTAO',
  'Loyalty Program View': 'LYTV',
  'Loyalty Program Update': 'LYTU',
  'Incentive Adjustment': 'INAD',
  'Reverse VolumeTransfer': 'RVT',
  'System Adminstration': 'SYSAD',
  SystemAdministrationUpdate: 'SYSAU',
  SystemAdministrationView: 'SYSAV',
  'Planned Manager Changes': 'PMC',
  'Planned Manager Changes View': 'PMCV',
  'Planned Manager Changes Create New Reports': 'PMCCR',
  'Planned Manager Changes Save New Report': 'PMSNR',
  'Planned Manager Changes Share Reports': 'PMCSR',
  'Planned Manager Changes Download Reports': 'PMCDR',
  'Audit Logs': 'ALS',
  'Audit Log Create New Reports': 'ALCR',
  'Audit Log Save New Reports': 'ALSNR',
  'Audit Log Share Reports': 'ALSR',
  'Audit Log Download Reports': 'ALDR',
  'Volume Adjustments': 'VOLAD',
  'Volume Adjustment Create': 'VAC',
  'Volume Adjustment Update': 'VAU',
  'Volume Adjustment Cancel': 'VACA',
  'Sales Order Report': 'SOR',
  'Sales Order View': 'SORV',
  'Sales Order Create New Reports': 'SORCR',
  'Sales Order Share Reports': 'SORSR',
  'Sales Order Save New Reports': 'SOSNR',
  'Sales Order Download Reports': 'SORDR',
  'Volume Adjustments Report - View Report': 'VARV',
  'Volume Adjustments Report - Create Report': 'VARC',
  'Volume Adjustments Report - Save Report': 'VARS',
  'Volume Adjustments Report - Share Reports': 'VARSH',
  'Volume Adjustments Report - Download Report': 'VARD',
  'AdvisorHistory': 'AHR',
  'Language Translation Access': 'LTA',
  'Language Translation Bulk Upload': 'LTBU',

   //VCE-18971 - Adhoc Payments access codes
   'Adhoc Payment Report': 'AHPR',
   'Adhoc Payment View': 'AHPRV',
   'Adhoc Payment Create Reports': 'AHPCR',
   'Adhoc Payment Save Reports': 'AHPS',
   'Adhoc Payment Share Reports': 'AHPSR',
   'Adhoc Payment Download Reports': 'AHPDR',

  'User Logon Report View': 'ULRV',
  'User Logon Report Update': 'INCAU',
  'User Logon Report - Create Reports': 'ULRCR',
  'User Logon Report - Save Reports': 'ULRSR',
  'User Logon Report - Share Reports': 'ULSHR',
  'User Logon Report - Download Reports': 'ULRDR',
  'Adjustment Download': 'ADJD',

  'Activity Logs': 'ACLG',
  'Activity Logs Create Reports': 'ACLCR',
  'Activity Logs Save Reports': 'ACLNR',
  'Activity Logs Share Reports': 'ACLSR',
  'Activity Logs Download Reports': 'ACLDR',

  // VCE:76750 - Archived reports
  'Archived Data' : 'ADG',
  'Archived Orders': 'AOR',
  'Archived Payments': 'APR',

  //Interface Monitoring
  'Interface Monitoring': 'IML',

};

export const DS_PRO_HELP_MENU_ID = {
    menuId: 0
};
export const ADJ_CONFIG_STMT_SEC_OPTIONS = ['MISC', 'INCOME'];
export const ADJ_CONFIG_STMT_MISC_OPTIONS = ['Credits/Adjustments', 'Bonuses Already Paid','Subscription Fee'];
export const ADJ_CONFIG_STMT_INCOME_OPTIONS = [
    'Lifetime Master Bonus',
    'Additional Bonuses',
    'International',
    'Fast Track Matching Bonus',
    'Fast Track'
];

export const LOCALE = {
    polandCode: 'PL',
    polandCurrency: 'PLN',
    defaultCode: 'en-US'
};
export const DUMMY_MATERIAL_GROUP_ID = {
    groupId: 2
};

export const Permissions = {
    "levelAccessLimit": "Level Access Limit",
    "menuPermFirstColumn": "Menu Item Name",
    "featurePermFirstColumn": "Feature Name",
    "detailPermFirstColumn": "Detail Card Name",
    "genPermFirstColumn": "Feature",
    "menus": {
      "HLD": "Historical Data",
      "HOM": "Home",
      "FOS": "Orders",
      "GLV": "Lineage Grid",
      "LNGV": "Lineage Grid",
      "DPR": "Director Promotion Report",
      "ALT": "Core Data",
      "BSP": "Business Setup",
      "ADM": "Administration",
      "MEM": "Participants",
      "BKM": "Bookmarks",
      "ALG": "Audit Log",
      "CSR": "Change Manager",
      "CER": "Change Recruiter",
      "TCS": "Tiered Compensations",
      "GBE": "Global Plan Elements",
      "UGS": "Users & Groups",
      "ORD": "Orders",
      "FST": "Field Support",
      "VTR": "Transfer Volume",
      "RTN": "Status Change",
      "CPG": "Commission Processing",
      "PBR": "Plan Manager",
      "DIN": "Data Integration",
      "PFL": "Profile",
      "FLP": "Field Lookup",
      "GLY": "Lineage",
      "LNG": "Lineage",
      "CPN": "Compensation",
      "ASP": "Application Setup",
      "DEM": "Demo",
      "RCV": "Recently Viewed",
      "PAL": "Payments",
      "TRF": "Transfer Volume",
      "MOVR": "Move Order Volume",
      "MNB": "Monthly Bonus",
      "CAJ": "Commissions Adjustments",
      "ENC": "Earning Codes",
      "UJE": "Unjust Enrichment",
      "DBU": "Salesforce Update",
      "CMB": "Commission Balance",
      "INCA": "Incentives",
      "CRBC": "Commission Run By ClientID",
      "MSR": "Misc Reports",
      "GDPR": "GDPR Configurations",
      "COR": "Change OrganizationUnit",
      "CPR": "Change Parent OrganizationUnit",
      "COD": "Change OrganizationUnit Downline",
      "UAT": "UAT Only",
      "SYSAD": "System Administration",
      "MVAR": "Volume Adjustments Report",
      "MPMC": "Planned Manager Changes",
      "ACG": "Access Log",
      "INTL": "Integration Logs",
      "SOR": "Sales Order Report",
      "DVS": "Data Views",
      "COM": "Commissions",
      "INBL": "Inbound Logs",
      "FMN": "No Side Menu",
      "AHR": "Advisor History",
      "ACLG": "Activity Logs",
      "ADG": "Archived Data"
    },
    "features": {
      "HLD": "Historical Data",
      "DPR": "Director Promotion Report",
      "FST": "Field Support",
      "FOS": "Orders",
      "ALS": "Audit Logs",
      "VTR": "Volume Transfer",
      "CAS": "Core Data",
      "TCS": "Tiered Compensations",
      "ADM": "Administration",
      "MEM": "Participants",
      "FLP": "Field Lookup",
      "GSR": "Share Reports",
      "FCN": "Create New Reports",
      "FSN": "Save New Reports",
      "GLY": "Lineage",
      "LNG": "Lineage",
      "GNDR": "Download Reports",
      "CNCR": "Create New Reports",
      "CASR": "Save New Reports",
      "TCCR": "Create New Reports",
      "TCSR": "Save New Reports",
      "UGS": "Users & Groups",
      "ORD": "Orders",
      "CVW": "Card View",
      "GDR": "Download Reports",
      "FSR": "Share Reports",
      "GVL": "Lineage View & Lookup",
      "CSR": "Change Manager",
      "CNSR": "Share Reports",
      "TSR": "Share Reports",
      "DIN": "Data Integration",
      "PFL": "Profile",
      "GVW": "Grid View",
      "DDV": "Salesforce Detail View",
      "FDR": "Download Reports",
      "GCN": "Create New Reports",
      "GSN": "Save New Reports",
      "RTN": "Status Change",
      "CNDR": "Download Reports",
      "TDR": "Download Reports",
      "DEM": "Demo",
      "PBLD": "Plan Manager",
      "PLU": "Plan Update",
      "PLV": "Plan View",
      "VOLU": "Volumes Update",
      "VOLV": "Volumes View",
      "TITU": "Title Update",
      "TITV": "Title View",
      "PTRU": "Price Tier Rules Update",
      "PTRV": "Price Tier Rules View",
      "EQLU": "Equivalences Update",
      "EQLV": "Equivalences View",
      "CBLD": "Compensation Builder",
      "CPGU": "Compensation Update",
      "CPGV": "Compensation View",
      "CPPU": "Bonuses Update",
      "CPPV": "Bonuses View",
      "CRCU": "Compensation Rate Card Update",
      "CRCV": "Compensation Rate Card View",
      "BSET": "Business Setup",
      "CMU": "Company Update",
      "CMV": "Company View",
      "CAUU": "Company Authentication Update",
      "CAUV": "Company Authentication View",
      "ACFU": "Audit Configuration Update",
      "ACFV": "Audit Configuration View",
      "MKRU": "Markets & Regions Update",
      "MKRV": "Markets & Regions View",
      "CBU": "Cross Border Update",
      "CBV": "Cross Border View",
      "PLPU": "Plan Period Update",
      "PLPV": "Plan Period View",
      "PPSDV": "Plan Period Segment Definition View",
      "ITSU": "Income Tax Setup Update",
      "ITSV": "Income Tax Setup View",
      "GLPE": "Global Plan Elements",
      "TTU": "Title Types Update",
      "TTV": "Title Types View",
      "PRTU": "PriceTier Update",
      "PRTV": "PriceTier View",
      "PTSU": "Participant Status Update",
      "PTSV": "Participant Status View",
      "OVU": "Overrides Update",
      "OVV": "Overrides View",
      "FLGU": "Flags Update",
      "FLGV": "Flags View",
      "GFU": "Group Function Update",
      "GFV": "Group Function View",
      "CCTV": "Cost Center Type View",
      "CCTU": "Cost Center Type Update",
      "JCU": "Job Configuration Update",
      "JCV": "Job Configuration View",
      "PCU": "Material Processing Update",
      "PCV": "Material Processing View",
      "GRU": "Rewards Update",
      "GRV": "Rewards View",
      "UGSU": "Users & Groups Update",
      "UGSV": "Users & Groups View",
      "GDPR": "GDPR Configurations",
      "JOBU": "Job Update",
      "JOBV": "Job View",
      "MEMU": "Members Update",
      "MEMV": "Members View",
      "ORDU": "Orders Update",
      "ORDV": "Orders View",
      "DBUU": "Salesforce Update Update",
      "DBUV": "Salesforce Update View",
      "PFLU": "Profile Update",
      "PFLV": "Profile View",
      "PAS": "Payments",
      "PASU": "Payment Update",
      "PASV": "Payment View",
      "USAU": "User Activity Update",
      "USAV": "User Activity View",
      "ALTV": "Core Data View",
      "COMP": "Commission Processing",
      "CMRU": "Commission Run Update",
      "CMRV": "Commission Run View",
      "PRDC": "Period Close",
      "PRRP": "Re-Process",
      "CDV": "Card View",
      "GDV": "Grid View",
      "GRCN": "Create New Reports",
      "GRSN": "Save New Reports",
      "GRSR": "Share Reports",
      "GRDR": "Download Reports",
      "VLTR": "Volume Transfer",
      "FOV": "Orders View",
      "TRV": "Tiered View",
      "FRXU": "Forex Rate Update",
      "FRXV": "Forex Rate View",
      "GENU": "Lineage Configuration Update",
      "GENV": "Lineage Configuration View",
      "LNGU": "Lineage Configuration Update",
      "LNGV": "Lineage Configuration View",
      "PACR": "Create New Reports",
      "PASR": "Save New Reports",
      "PASH": "Share Reports",
      "PADR": "Download Reports",
      "CFU": "Charges & Fees Update",
      "CFV": "Charges & Fees View",
      "UJEV": "Unjust Enrichment View",
      "GSTU": "Global Settings Update",
      "GSTV": "Global Settings View",
      "TRPU": "Training Program Update",
      "TRPV": "Training Program View",
      "INCU": "Incentive Update",
      "INCV": "Incentive View",
      "INPU": "Incentive Plan Update",
      "INPV": "Incentive Plan View",
      "INPOU": "Incentive Point Update",
      "INPOV": "Incentive Point View",
      "INCA": "Incentives",
      "INCAU": "Incentives Update",
      "INCAV": "Incentives View",
      "INCCR": "Create New Reports",
      "INCSR": "Save New Reports",
      "INCSH": "Share Reports",
      "INCDR": "Download Reports",
      "TRAU": "Translation Update",
      "TRAV": "Translation View",
      "CRBCV": "Commission Run by ClientID View",
      "CRBCU": "Commission Run by ClientID Update",
      "HLPU": "Help Update",
      "PHTJ": "Period High Title Job",
      "VOLAD": "Volume Adjustments",
      "PMC": "Planned Manager Changes",
      "PMCV": "Planned Manager Changes View",
      "PMSNR": "Planned Manager Changes - Save Reports",
      "PMCCR": "Planned Manager Changes - Create Reports",
      "PMCSR": "Planned Manager Changes - Share Reports",
      "PMCDR": "Planned Manager Changes - Download Reports",
      "SOR": "Sales Order Report",
      "SORV": "Sales Order Report View",
      "SOSNR": "Sales Order - Save Reports",
      "SORCR": "Sales Order - Create Reports",
      "SORSR": "Sales Order - Share Reports",
      "SORDR": "Sales Order - Download Reports",
      "ALCR": "Audit Logs - Create Reports",
      "ALSNR": "Audit Logs - Save Reports",
      "ALSR": "Audit Logs - Share Reports",
      "ALDR": "Audit Logs - Download Reports",
      "LTBU": "Language Translation Bulk Upload",
      "LT": "Language Translation",
      "LTC": "Language Translation Create",
      "LTU": "Language Translation Update",
      "LTCA": "Language Translation Cancel",
      "COR": "Change OrganizationUnit",
      "COD": "Change OrganizationUnit Downline",
      "CPR": "Change Parent OrganizationUnit",
      "SPRC": "Sub Period Close",
      "DCS": "Download Combined Statement",
      "GVOLU": "Volumes Update",
      "GVOLV": "Volumes View",
      "VAC": "Volume Adjustment Create",
      "VAU": "Volume Adjustment Update",
      "VACA": "Volume Adjustment Cancel",
      "VAR": "Volume Adjustments Report View",
      "VARV": "Volume Adjustments Report - View Report",
      "VARS": "Volume Adjustments Report - Save Report",
      "VARC": "Volume Adjustments Report - Create Report",
      "VARSH": "Volume Adjustments Report - Share Report",
      "VARD": "Volume Adjustments Report - Download Report",
      "DBS": "Download Bonus Statement",
      "INAD": "Incentive Adjustment",
      "INTL": "Integration Logs",
      "KMU": "Key Metrics Update",
      "KMV": "Key Metrics View",
      "IPBU": "Incentive Points Upload",
      "OMNCU": "Value Chain Update",
      "OMNCV": "Value Chain View",
      "LEVU":"Level Update",
      "LEVV": "Level View",
      "CPU":"Challenge Program Update",
      "CPV": "Challenge Program View",
      "VCRU": "Value Chain Rule Update",
      "VCRV": "Value Chain Rule View",
      "VCV": "Volume Configuration View",
      "VCU": "Volume Configuration Update",
      "UAT": "UAT Only",
      "SYSAU": "SystemAdministrationUpdate",
      "SYSAV": "SystemAdministrationView",
      "INBL": "InboundLogs",
      "CADJ": "Commissions Adjustments",
      "EPRU": "Ep Retro Update",
      "INBU": "Incentive Enrollments",
      "VABU": "Volume Adjustment Upload",
      "APBU": "Adhoc Payment - Bulk Upload",
      "CORG": "Change Org - Bulk Upload",
      "BLKPD": "Promote Demote - Bulk Upload",
      "SFEP": "Stop Future Earning Program",
      "MAP": "Material Processing",
      "UJE": "Unjust Enrichment",
      "RVT": "Reverse VolumeTransfer",
      "AHR": "Advisor History",
      "AHPR": "Adhoc Payment Report",
      "AHPRV": "Adhoc Payment View",
      "AHPCR": "Adhoc Payment Create Reports",
      "AHPS": "Adhoc Payment Save Reports",
      "AHPSR": "Adhoc Payment Share Reports",
      "AHPDR": "Adhoc Payment Download Reports",
      "ULOR": "User Logon Report",
      "ULRV": "User Logon Report View",
      "ULRCR": "User Logon Report - Create Reports",
      "ULRSR": "User Logon Report - Save Reports",
      "ULSHR": "User Logon Report - Share Reports",
      "ULRDR": "User Logon Report - Download Reports",
      "PPSDU": "Plan Period Segment Definition Update",
      "ACLG": "Activity Logs",
      "ACLCR": "Activity Logs Create Reports",
      "ACLNR": "Activity Logs Save Reports",
      "ACLSR": "Activity Logs Share Reports",
      "ACLDR": "Activity Logs Download Reports",
      "ADG": "Archived Data"
    },
    "details": {
      "AIN": "Achievement Information",
      "CPN": "Compensation",
      "FLG": "Flags",
      "PCS": "Promotion Controls",
      "VGM": "Volume Grace Month",
      "ALV": "All Volumes",
      "COS": "Current Overrides",
      "GLY": "Lineage",
      "LNG": "Lineage",
      "QPS": "Qualified Periods",
      "VOL": "Volumes",
      "BCD": "Business Card",
      "DIS": "Salesforce Information",
      "GMT": "Group Management",
      "SIN": "Shipping Information",
      "CPM": "Car Program",
      "FSS": "Fast Start Status",
      "ORD": "Orders",
      "SPN": "Manager Information",
      "CNT": "Contact Information",
      "ACH": "Achievement",
      "BNE": "Bonus and Earnings",
      "BBR": "Bonus Breakdown",
      "ACA": "Account and Adjustments",
      "NOT": "Notes",
      "COR": "Organizational Unit",
      "LEG": "Legacy Order",
      "PAM": "Proxy & Master",
      "AHP": "Adhoc Payments",
      "REDIN": "Redeem Incentives",
      "CCT": "Cost Center",
      "TPDC": "Promotion or Demotion",
      "ENP": "Program",
      "LT": "Language Translation",
      "GEN": "Genealogy",
      "OVR": "Overrides",
      "VLM": "Progress and Volumes",
      "INCST": "Incentive Status"
    },
    "genealogy": {
      "GLV": "Lineage View",
      "LNG": "Lineage View"
    },
    "accessTypes": {
      "NAC": "No Access",
      "ACC": "Access",
      "FAC": "Feature Access",
      "RAC": "Read Access",
      "WAC": "Write Access",
      "CAC": "Card Menu Access"
    }
};

export const FLAG_TYPE_OPTIONS = [
  { id: 1, name: "DVB1 Flag" },
  { id: 2, name: "DVB2 Flag" }
];

export const RC_BONUS_TYPES = {
    TMPL_SCNB: 'TMPL-SCNB',
    KSPL_SCNB:'KSPL-SCNB'
};

export const STATUS_CODES = {
    successCode: 'SUCC',
    failedCode: 'FLD',
    stopCode: 'STP',
    inactiveCode: 'INAC'
};

export const COMMISSION_RUN_CODES= {
    periodClose: 'PERIOD_CLOSE',
    completed: 'COMPLETED',
    subPeriodClose : 'SUB_PERIOD_CLOSE'
};

export const DD_GENEALOGY_TABS = {
    vipTLRank: 221,
    vipGroup: "VIP Group",
    addVIPGroup: "addVIPGroup"
};
export const GENEALOGY_COlUMN = {
    lastName : "Last Name"
}
export const MATERIAL_TYPES = {
    material: 'Material',
    materialGroup: 'Material Group',
};
export const OPERATOR_TYPES = [
  { id: 1, name: "AND" },
  { id: 2, name: "OR" },
  { id: 3, name: "COMBINATION" }
];
export const ADMIN_EMAIL = 'admin@dspro.com';
